<template>
  <div class="overzicht-consoles">
    <table cellspacing="0">
      <thead>
        <tr>
          <th>Naam</th>
          <th>Laatste activiteit</th>
          <th>Status</th>
          <th>Acties</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="c in consoles" :key="c.Id">
          <td class="col">{{c.Naam}}</td>
          <td class="col">{{c.LaatsteActiviteit}}</td>
          <td class="col">{{c.Status}}</td>
          <td class="col"><button @click="reset(c)">Reset</button></td>
        </tr>
      </tbody>
    </table>
    <v-btn @click="getConsoles()" color="primary">Refresh</v-btn>
  </div>
</template>


<script>
export default {
  name: "overzichtconsoles",
  components: {},
  data() {
    return {
      consoles: []
    };
  },
  methods: {
    getConsoles: function() {
      this.$api.pOverzichtConsoles().then(response => {
        this.consoles = response.data;
      });
    },
    reset: function(aconsole) {
        this.$api.pResetConsole({ConsoleId: aconsole.Id}).then(() => {
            this.getConsoles();
            alert('Console '+aconsole.Naam+' is gereset.');
          });
    }
  },
  created: function() {
    this.getConsoles();
  }
};
</script>


<style scoped>
table {
  width: 100%;
  margin-bottom: 15px;
  border: 1px solid silver;
}

.rapport-sessie {
  margin-top: 10px;
  margin-bottom: 20px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

tr,
td {
  border-width: 0px;
}

.col-l {
  width: 50%;
}
.col-r {
  width: 50%;
}

thead {
  background-color: #00b4d1;
  color: #fff;
}

th {
    text-align: left;
}
</style>
